import React, { Component } from "react";
// styles for page
import "./reg_step3.css";
// icons for page
import Ionicon from "react-ionicons";
// request module
import axios from "axios";
// navigaion arrows
import { NavigationArrow, edit } from "../other components/navigation_arrow";
import { Saved } from "../other components/savedAlert";
// cropper module
import "cropperjs/dist/cropper.css";
import Cropper from "react-cropper";

export default class RegStep3 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      subImage: null,
      subHeading: null,
      subHeadingInitial: "OUT OF STOCK",
      subDesc: null,
      subDescInitial: `Oops! Sorry we are currently out of stock.\n Please leave your email and we will contact you as soon as the product will be aviable `,
      subButtonValue: null,
      subButtonValueInitial: "SUBSCRIBE NOW",
      subComplete: null,
      subCompleteInitial: "You have been succesfully subscribed",
      saved: false,
      history: {
        // field history and current index
        subImage: [null],
        subImageIndex: 0,
        //
        subHeading: [null],
        subHeadingIndex: 0,
        //
        subDesc: [null],
        subDescIndex: 0,
        //
        subButtonValue: [null],
        subButtonValueIndex: 0,
        //
        subComplete: [null],
        subCompleteIndex: 0,
        // last modified element
        lastModifiedElement: [null],
        lastModifiedElementIndex: 0
      }
    };
    this.actionStep = 1;
  }
  // add drag event
  componentDidMount = () => {
    let dragArea = [document.getElementsByClassName("labelUploadsubImage")[0]];
    dragArea.map((item, index) => {
      // get the last class name
      let list = item.classList;
      let dragAreaClass = list[list.length - 1];
      dragArea[index].addEventListener("dragenter", this.dragenter, false);
      dragArea[index].addEventListener("dragleave", this.dragleave, false);
      dragArea[index].addEventListener("dragover", this.dragover, false);
      dragArea[index].addEventListener("drop", this.handleOnchange, false);
    });
  };
  // drag and drop
  dragenter = e => {
    e.stopPropagation();
    e.preventDefault();
  };
  dragleave = e => {
    e.stopPropagation();
    e.preventDefault();
  };
  dragover = e => {
    e.stopPropagation();
    e.preventDefault();
  };
  componentDidUpdate=()=>{
    if (this.state.subImage) {
      document.getElementsByClassName(
        "labelUploadsubImage"
      )[0].style.display = "none";
      document.getElementsByClassName(
        "labelUploadsubImage"
      )[0].style.backgroundColor = "transparent";
    } else {
      document.getElementsByClassName(
        "labelUploadsubImage"
      )[0].style.display = "flex";
      document.getElementsByClassName(
        "labelUploadsubImage"
      )[0].style.backgroundColor = "#f2f2f2";
      this.removeImageCache("subImage_upload");
    }
  }
  //
  // remove cache
  removeImageCache = img => {
    document.getElementById(img).value = "";
  };
  // get bloob url from file
  getUrlFromObj = e => {
    let imagePreview;
    let binaryData = [];
    if (e) {
      binaryData.push(e);
      imagePreview = window.URL.createObjectURL(new Blob(binaryData));
      return imagePreview;
    }
    return;
  };
  // get image preview from input files
  handleOnchange = event => {
    event.stopPropagation();
    event.preventDefault();
    let file = event.target.files || event.dataTransfer.files;
    let fileSize = file[0].size/1024;
    if (
      ((event.target && file.length != 0) ||
        (event.dataTransfer && file.length != 0)) &&
      fileSize < 500
    ) {
      // let labelClass = "labelUpload" + event.target.name;
      let labelClass = event.target.closest("label");
      let str = labelClass.className;
      let stateName = str.substr(
        str.search("labelUpload") + "labelUpload".length,
        str.length
      );
      labelClass.style.display = "none";
      labelClass.parentElement.style.backgroundColor="transparent";
      this.setState(
        { [stateName]: this.getUrlFromObj(file[0]) },
        this.handleEditor(this.getUrlFromObj(file[0]), stateName)
      );
      this.handleHistory(stateName, this.getUrlFromObj(file[0]));
    } else if (fileSize > 500) {
      alert("invalid file size,recommended size 500kb  ");
    } else {
      return false;
    }
  };
  handleChange = event => {
    this.setState({
      [event.target.name]: event.target.value
    },
    this.handleHistory(event.target.name, event.target.value)
  );
  };
   // modify history object
   handleHistory = (name, value) => {
    // create copy of history obbject for manipulation
    let history = this.state.history;
    if (history.lastModifiedElement.length > 15) {
      history= {
        // field history and current index
        subImage: [null],
        subImageIndex: 0,
        //
        subHeading: [null],
        subHeadingIndex: 0,
        //
        subDesc: [null],
        subDescIndex: 0,
        //
        subButtonValue: [null],
        subButtonValueIndex: 0,
        //
        subComplete: [null],
        subCompleteIndex: 0,
        // last modified element
        lastModifiedElement: [null],
        lastModifiedElementIndex: 0
      }
    }
    // add value  to history array
    history[name].push(value);
    history[`${name}Index`] = history[`${name}Index`] + this.actionStep;
    // // reset last modified
    history.lastModifiedElement.push(name);
    history.lastModifiedElementIndex = history.lastModifiedElement.length - 1;
    this.setState({ history: history });
  };
  actionUndo = command => {
    // document.execCommand(command, false, null);
    // clone history object
    let history = this.state.history;
    let lastElementKey = history.lastModifiedElementIndex;
    let action = history.lastModifiedElement[lastElementKey];

    let key = null;
    let value = null;
    if (
      action &&
      history[`${action}Index`] <= history[action].length &&
      lastElementKey > 0
    ) {
      console.log(history[action].length);
      if (command === "undo") {
        history.lastModifiedElementIndex = history.lastModifiedElementIndex - 1;
        // get action by lastmodified element  index
        //  undo step /3
        history[`${action}Index`] = history[`${action}Index`] - this.actionStep;
      }
      if (command === "redo") {
        history.lastModifiedElementIndex = history.lastModifiedElementIndex + 1;
        //  undo step /3
        history[`${action}Index`] = history[`${action}Index`] + this.actionStep;
      } else if (history[`${action}Index`] > history[action].length) {
        return false;
      }
      // change last modified element index
      key = history[`${action}Index`];
      if (key <= 0) {
        value = "";
      } else if (key > 0 && key < 16) {
        value = history[action][key];
      }
    } else {
      return false;
    }
    console.log(action);
    // get last action field name
    let ev = {
      target: {
        name: action,
        value: value
      }
    };

    this.setState(
      {
        [action]: value,
        history: history
      },
      () => this.handleCheck(ev)
    );
  };
  // empty textarea on focus
  handleOnFocus = event => {
    event.preventDefault();
    event.target.placeholder = "";
  };
  // check if textarea value equal to 0 return default value
  handleCheck = event => {
    let value = event.target.value;
    let name = event.target.name;
    if (value == 0 || value == "") {
      event.target.placeholder = this.state[name + "Initial"];
    }
  };

  componentWillReceiveProps = nextProps => {
    if (nextProps.save && nextProps.save === 3 && nextProps.show === 1)
      this.SendData();
      let action = nextProps.action;
      if (action) {
        this.actionUndo(action);
      }
  };
  // empty textarea on focus
  handleOnFocus = event => {
    event.preventDefault();
    event.target.placeholder = "";
  };
  // check if textarea value equal to 0 return default value
  handleCheck = event => {
    let value = event.target.value;
    let name = event.target.name;
    if (value === 0 || value === "" || value === null) {
      document.getElementsByName(name)[0].placeholder = this.state[
        name + "Initial"
      ];
    }
  };
  removeUpload = eventItem => {
    let labelClass = "labelUpload" + eventItem;
    document.getElementsByClassName(labelClass)[0].style.display = "block";
    document.getElementsByClassName(labelClass)[0].parentElement.style.backgroundColor="#f2f2f2";
    this.setState(
      {
        [eventItem]: null
      },
      this.removeImageCache(eventItem + "_upload")
    );
  };
  
  // calls to open editor
  handleEditor = (img, key) => {
    this.setState({
      editorOpen: true,
      activeImg: img,
      activeImgKey: key
    });
    document.body.style.overflow = "hidden";
  };
  // editor initiallize settings
  editorInitializze = () => {
    let cropper = this.refs.cropper;
    let image = this.refs.cropper.getImageData();
    cropper.setCanvasData({
      widtht: image.width,
      height: image.height
    });
    cropper.setCropBoxData({
      widtht: image.width,
      height: image.height
    });
  };
  // cropper module actions
  editorAction = action => {
    let activeImage = this.refs.cropper;
    switch (true) {
      case action == "rotate":
        activeImage.rotate(90);
        break;
      case action == "crop":
        let canvas = activeImage.getCroppedCanvas({
          width: activeImage.getCropBoxData().width,
          heigh: activeImage.getCropBoxData().height
        });
        activeImage.replace(canvas.toDataURL(), false);
        break;
      case action == "save" || action == "close":
        let canvasFinish = null;
        let key = this.state.activeImgKey;
        if (action == "save") {
          canvasFinish = activeImage.getCroppedCanvas({
            width: activeImage.getCropBoxData().width,
            heigh: activeImage.getCropBoxData().height
          });
        }
        if (action == "close") {
          activeImage.setCropBoxData({
            width: 600,
            left: 100
          });
          canvasFinish = activeImage.getCroppedCanvas({
            width: activeImage.getCropBoxData().width,
            heigh: activeImage.getCropBoxData().height
          });
        }

        if (canvasFinish) {
          this.setState(
            { [key]: canvasFinish.toDataURL() },
            this.closeEditor()
          );
        }
        break;
      case action == "undo":
        activeImage.replace(this.state.activeImg, false);
        break;
    }
  };
  // close editor view
  closeEditor = () => {
    this.setState({
      editorOpen: false,
      activeImg: null,
      activeImgKey: null
    });
    document.body.style.overflow = "auto";
  };
  SendData = () => {
    let formData = new FormData();
    formData.append(
      "image",
      new File([this.state.subImage], "productPhoto", {
        type: "image/jpg",
        lastModified: Date.now()
      })
    );
    let data = JSON.stringify({
      subHeading: this.state.subHeading,
      subDesc: this.state.subDesc,
      subButtonValue: this.state.subButtonValue,
      subComplete: this.state.subComplete
    });
    formData.append("sub", window.localStorage.getItem("subdomain"));
    formData.append("page", "third page");
    formData.append("type", "page");
    formData.append("data", data);
    // your request here
    for (var pair of formData.entries()) {
      console.log(pair[0] + ", " + pair[1]);
    }
  };
  saveAlert = () => {
    setTimeout(
      () =>
        this.setState({
          saved: true
        }),
      0
    );
    setTimeout(
      () =>
        this.setState({
          saved: false
        }),
      1500
    );
  };
  // check if enter pressed on textarea
  handleKeyPress = e => {
    let code = e.keyCode ? e.keyCode : e.which;
    if (code === 13) {
      e.target.blur();
    }
  };

  render = () => {
    // check show close button or not

    let showCloseButton;
    this.state.subImage ? (showCloseButton = true) : (showCloseButton = false);
    let style;
    this.props.show
      ? (style = { display: "block" })
      : (style = { display: "none" });
    return (
      <div
        className="regStep step3"
        onClick={this.handleChangeEditable}
        style={style}
      >
        <div className="row">
          <div className="imageUpload">
            {showCloseButton && (
              <Ionicon
                icon="ios-close-circle"
                fontSize={30}
                className="removeIcon"
                color="#f9dd31"
                onClick={() => this.removeUpload("subImage")}
              />
            )}
            <label
              htmlFor="subImage_upload"
              id="labelUpload"
              className="labelUploadsubImage"
            >
              <div className="parentSection">
                <div className="perfectCenter">
                  <Ionicon icon="md-camera" fontSize="70" color="#bdc3c7" />
                </div>
                <div className="perfectCenter">
                  <p className="big">
                    Drag {"&"} Drop or click here <br /> to upload <br /> the
                    best photo of your product{" "}
                  </p >
                  <p className="small">recomended size bla bla bla</p>
                </div>
              </div>
              <input
                type="file"
                onChange={this.handleOnchange}
                accept=".jpg"
                id="subImage_upload"
                name="subImage"
                accept="image/*"
              />
            </label>
            {this.state.subImage ? (
              <img
                src={this.state.subImage}
                onClick={() =>
                  this.handleEditor(this.state.subImage, "productPhoto3")
                }
              />
            ) : null}
          </div>
          <label className="labelforHover">
            <textarea
              tabIndex={1}
              spellCheck={false}
              value={this.state.subHeading}
              placeholder={this.state.subHeadingInitial}
              onChange={this.handleChange}
              onFocus={this.handleOnFocus}
              onBlur={this.handleCheck}
              className="heading area"
              name="subHeading"
              rows="1"
              maxLength="20"
            />
            {edit(40)}
          </label>
          <label className="labelforHover">
            <textarea
              tabIndex={2}
              spellCheck={false}
              value={this.state.subDesc}
              placeholder={this.state.subDescInitial}
              onChange={this.handleChange}
              onFocus={this.handleOnFocus}
              onBlur={this.handleCheck}
              className="description area grayTxt"
              name="subDesc"
              rows="2"
              maxLength="20"
            />
            {edit(40)}
          </label>
          <label className="subscribeForm">
            <input type="text" placeholder="Your email" disabled />
            <button className="yButton">
              <label className="labelforHover">
                <textarea
                
                  spellCheck={false}
                  tabIndex={3}
                  maxLength="13"
                  value={this.state.subButtonValue}
                  placeholder={this.state.subButtonValueInitial}
                  onKeyPress={this.handleKeyPress}
                  onChange={this.handleChange}
                  onFocus={this.handleOnFocus}
                  onBlur={this.handleCheck}
                  name="subButtonValue"
                  rows="1"
                  className="buttonArea"
                />
                {edit(30)}
              </label>
            </button>
          </label>
          <label className="labelforHover">
            <textarea
              tabIndex={4}
              spellCheck={false}
              value={this.state.subComplete}
              placeholder={this.state.subCompleteInitial}
              onChange={this.handleChange}
              onFocus={this.handleOnFocus}
              onBlur={this.handleCheck}
              className="description area subComplete"
              name="subComplete"
              rows="1"
              maxLength="30"
            />
            {edit(40)}
          </label>
        </div>
        <span
          onClick={() => {
            this.props.step("back");
          }}
        >
          {NavigationArrow("prev")}
        </span>

        <span
          onClick={() => {
            this.props.step("forward");
          }}
        >
          {NavigationArrow("next")}
        </span>
        {this.state.saved && Saved}
        {this.state.editorOpen && (
          <div className="overlayEditor">
            <Cropper
              ref="cropper"
              src={this.state.activeImg}
              className="editorBody"
              // Cropper.js options
              autoCrop={true}
              aspectRatio={3.2}
              background={false}
              guides={false}
              ready={this.editorInitializze}
              center={true}
              zoomable={false}
            />
            <div className="editorTools perfectCenter">
              <Ionicon
                icon="ios-undo"
                className="editorButton"
                fontSize="40px"
                color="white"
                onClick={() => this.editorAction("undo")}
              />
              <Ionicon
                icon="ios-crop-outline"
                className="editorButton"
                fontSize="50px"
                color="white"
                onClick={() => this.editorAction("crop")}
              />
              <Ionicon
                icon="ios-refresh"
                className="editorButton"
                fontSize="50px"
                color="white"
                onClick={() => this.editorAction("rotate")}
              />
              <div className="editorButtonGroup">
                <Ionicon
                  icon="ios-checkmark"
                  className="editorButton"
                  fontSize="60px"
                  color="white"
                  onClick={() => this.editorAction("save")}
                />
                <Ionicon
                  icon="ios-close"
                  className="editorButton"
                  fontSize="60px"
                  color="white"
                  onClick={() => this.editorAction("close")}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    );
  };
}
